(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-by-collection-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-by-collection-product')) {
    customElements.define(
      'article-by-collection-product',
      class ArticleByCollectionProduct extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.handle = new URLSearchParams(window.location.search).get('ecomativesby')?.trim().toLowerCase();
          if (!this.handle || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(this.handle)) return;

          this.sectionElement = this.closest('.shopify-section');
          if (!this.sectionElement) return;

          this.cardTemplate = null;
          this.mutationTimer = null;
          this.observer = new MutationObserver(() => {
            window.clearTimeout(this.mutationTimer);
            this.mutationTimer = window.setTimeout(() => this.promote(), 0);
          });
          this.observer.observe(this.sectionElement, { childList: true, subtree: true });

          this.load();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.clearTimeout(this.mutationTimer);
        }

        getGrid() {
          return this.sectionElement.querySelector('ul#main-collection-product-grid.productListing');
        }

        getHandleFromLink(link) {
          try {
            const parts = new URL(link.href, window.location.origin).pathname.split('/products/');
            return parts.length === 2 ? parts[1].split('/')[0].toLowerCase() : '';
          } catch (error) {
            return '';
          }
        }

        findItem(root) {
          return Array.from(root.querySelectorAll('li.product')).find((item) => {
            if (item.dataset.articleByHandle === this.handle) return true;

            return Array.from(item.querySelectorAll('a[href*="/products/"]')).some(
              (link) => this.getHandleFromLink(link) === this.handle
            );
          });
        }

        promote() {
          const grid = this.getGrid();
          if (!grid) return false;

          let item = this.findItem(grid);
          if (!item && this.cardTemplate) {
            item = this.cardTemplate.cloneNode(true);
            grid.prepend(item);
          }

          if (!item) return false;

          item.dataset.articleByHandle = this.handle;
          if (!this.cardTemplate) this.cardTemplate = item.cloneNode(true);
          if (grid.firstElementChild !== item) grid.prepend(item);
          return true;
        }

        async load() {
          if (this.promote()) return;

          try {
            const shopRoot = window.Shopify?.routes?.root || '/';
            const response = await fetch(
              `${shopRoot}products/${encodeURIComponent(this.handle)}?section_id=article-by-product`,
              { headers: { Accept: 'text/html' } }
            );
            if (!response.ok) return;

            const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const item = this.findItem(responseDocument);
            if (!item) return;

            item.dataset.articleByHandle = this.handle;
            this.cardTemplate = item.cloneNode(true);
            this.promote();
          } catch (error) {
            return;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lining-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-addons')) {
        customElements.define('product-addons', class ProductAddons extends HTMLElement {
            connectedCallback() {
                this.form = document.getElementById(this.dataset.formId);
                this.variantInput = this.form?.querySelector('input[name="id"]');
                this.controls = Array.from(this.querySelectorAll('[data-product-addon-input]'));
                this.count = this.querySelector('[data-addon-count]');
                this.variants = JSON.parse(this.querySelector('[data-addon-variants]')?.textContent || '[]');
                this.excludedTitles = (this.dataset.excludedVariantTitles || '')
                    .split(/[\n,]/)
                    .map((title) => title.trim().toLowerCase())
                    .filter(Boolean);

                this.addEventListener('change', () => this.updateCount());
                this.variantInput?.addEventListener('change', () => this.updateVisibility());
                this.updateVisibility();
                this.updateCount();
            }

            updateVisibility() {
                const variant = this.variants.find((item) => String(item.id) === String(this.variantInput?.value));
                const variantValues = [variant?.title, ...(variant?.options || [])]
                    .filter(Boolean)
                    .map((value) => value.trim().toLowerCase());
                const isExcluded = this.excludedTitles.some((title) => variantValues.includes(title));

                this.hidden = isExcluded;
                this.controls.forEach((control) => {
                    if (isExcluded) {
                        if (control.matches('input')) control.checked = false;
                        if (control.matches('select')) control.value = '';
                    }
                    control.disabled = isExcluded || control.dataset.available === 'false';
                });
                this.updateCount();
            }

            updateCount() {
                if (!this.count) return;
                const selected = this.querySelectorAll('input[data-product-addon-input]:checked').length;
                const select = this.querySelector('select[data-product-addon-input]');
                const selectedCount = select?.value ? 1 : selected;
                this.count.textContent = selectedCount
                    ? `${selectedCount} ${this.count.dataset.selectedLabel}`
                    : this.count.dataset.optionalLabel;
            }
        });
    }
  } catch(e) { console.error(e); }
})();

})();
